<empathy-viewer-card [fullSize]="fullSize()" [fitBox]="fitBox()" class="empathy-viewer-template-card__wrapper">
  <div slot="content" class="empathy-viewer-template-card__wrapper__content">
    <ng-content select="[slot=stimulus]"></ng-content>

    @if (!noHeader()) {
      <div class="empathy-viewer-template-card__wrapper__content__header">
        <ng-content select="[slot=title]"></ng-content>
        <ng-content select="[slot=subtitle]"></ng-content>
      </div>
    }

    <div class="empathy-viewer-template-card__wrapper__content__details" [class.full-size]="fullSize()">
      <ng-content select="[slot=details]"></ng-content>
      <ng-content select="[slot=actions]"></ng-content>
    </div>
  </div>
</empathy-viewer-card>
